
import { setStorage } from '@/utils/storage'
import { STORAGE_CHANGE_INFO, STORAGE_CHANGE_FAILED_INFO } from '@/utils/train-storage'

export default {
  setChangeOrderInfo(state, payload) {
    state.changeOrderInfo = payload || {}
    setStorage({ key: STORAGE_CHANGE_INFO, data: payload })
  },
  setChangeFailedOrderInfo(state, payload) {
    state.changeFailedOrderInfo = payload
    setStorage({ key: STORAGE_CHANGE_FAILED_INFO, data: payload })
  },
}
